import { render, staticRenderFns } from "./Modal_image.vue?vue&type=template&id=4c220e24&"
import script from "./Modal_image.vue?vue&type=script&lang=js&"
export * from "./Modal_image.vue?vue&type=script&lang=js&"
import style0 from "./Modal_image.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports